import React from 'react';
import { LucideIcon } from 'lucide-react';

export interface FilterFieldProps {
  label: string;
  icon?: LucideIcon;
  children: React.ReactNode;
}

const FilterField: React.FC<FilterFieldProps> = ({ label, icon: Icon, children }) => {
  return (
    <div className="sm:col-span-1">
      <label className="block text-sm font-semibold text-gray-700 dark:text-gray-300 mb-2">
        <div className="flex items-center gap-2">
          {Icon && <Icon className="w-4 h-4 text-indigo-600 dark:text-indigo-400" />}
          <span>{label}</span>
        </div>
      </label>
      {children}
    </div>
  );
};

export default FilterField;

